import { defineFeatureappService } from "@volkswagen-onehub/featureapp-service";
export const featureAppServiceFactory = (configs) => {
    const configMap = Object.fromEntries(configs.map((config) => {
        return [
            config.name,
            {
                name: config.name,
                src: config.client,
                baseUrl: config.baseUrl,
                css: config.css.map((cssUrl) => {
                    return { href: cssUrl };
                }) || [],
            },
        ];
    }));
    return defineFeatureappService(configMap);
};
